var _path, _path2, _path3, _ellipse, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgModoBup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5724 124.899C101.309 124.899 123.793 102.415 123.793 74.6786C123.793 46.9424 101.309 24.4578 73.5724 24.4578C45.8362 24.4578 23.3516 46.9424 23.3516 74.6786C23.3516 102.415 45.8362 124.899 73.5724 124.899Z",
    fill: "#BDF5F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2222 38.2692C32.2222 35.0979 34.7895 32.5271 37.9564 32.5271H88.7102C91.8771 32.5271 94.4444 35.0979 94.4444 38.2692V95.8127C94.4444 98.984 91.8771 101.555 88.7102 101.555H37.9564C34.7895 101.555 32.2222 98.984 32.2222 95.8127V38.2692Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7102 34.4819H37.9564C35.8676 34.4819 34.1742 36.1775 34.1742 38.2692V95.8127C34.1742 97.9044 35.8676 99.6001 37.9564 99.6001H88.7102C90.799 99.6001 92.4923 97.9044 92.4923 95.8127V38.2692C92.4923 36.1775 90.799 34.4819 88.7102 34.4819ZM37.9564 32.5271C34.7895 32.5271 32.2222 35.0979 32.2222 38.2692V95.8127C32.2222 98.984 34.7895 101.555 37.9564 101.555H88.7102C91.8771 101.555 94.4444 98.984 94.4444 95.8127V38.2692C94.4444 35.0979 91.8771 32.5271 88.7102 32.5271H37.9564Z",
    fill: "#4C2D86"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5724_63162",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 56,
    width: 26,
    height: 26
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.9305,
    cy: 69.1243,
    rx: 12.8472,
    ry: 12.8472,
    fill: "#DEF3F4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5724_63162)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.9305,
    cy: 69.1243,
    rx: 12.8472,
    ry: 12.8472,
    fill: "#74D8D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0405 71.7959C34.6626 70.7039 35.9029 67.6931 34.8109 65.071C33.7189 62.449 30.7081 61.2086 28.086 62.3006C25.464 63.3926 24.2236 66.4034 25.3156 69.0255C26.4076 71.6476 29.4185 72.8879 32.0405 71.7959Z",
    fill: "#6B3BAA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0638 73.9519C24.7954 73.9519 20.5225 78.2228 20.5225 83.4932C20.5225 84.8751 21.6433 85.9959 23.0251 85.9959H37.1004C38.4823 85.9959 39.6031 84.8751 39.6031 83.4932C39.6031 78.2249 35.3322 73.9519 30.0618 73.9519H30.0638Z",
    fill: "#6B3BAA"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4681 64.3325C47.8833 64.3325 46.6451 61.1578 48.5473 59.4078C50.2974 57.5055 53.4721 58.7437 53.4721 61.3285V61.4487C53.4721 63.0414 52.181 64.3325 50.5883 64.3325H50.4681Z",
    fill: "#17BEBB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7222 41.8326C49.7222 39.9917 51.2146 38.4993 53.0555 38.4993H113.472C115.313 38.4993 116.806 39.9917 116.806 41.8326V60.9993C116.806 62.8402 115.313 64.3326 113.472 64.3326H53.0555C51.2146 64.3326 49.7222 62.8402 49.7222 60.9993V41.8326Z",
    fill: "#17BEBB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7776 44.402C57.7776 43.6733 58.3683 43.0825 59.097 43.0825H107.569C108.298 43.0825 108.889 43.6733 108.889 44.402C108.889 45.1307 108.298 45.7214 107.569 45.7214H59.097C58.3683 45.7214 57.7776 45.1307 57.7776 44.402Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7776 51.4853C57.7776 50.7566 58.3683 50.1659 59.097 50.1659H107.569C108.298 50.1659 108.889 50.7566 108.889 51.4853C108.889 52.214 108.298 52.8047 107.569 52.8047H59.097C58.3683 52.8047 57.7776 52.214 57.7776 51.4853Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7776 58.5686C57.7776 57.8399 58.3683 57.2492 59.097 57.2492H107.569C108.298 57.2492 108.889 57.8399 108.889 58.5686C108.889 59.2973 108.298 59.8881 107.569 59.8881H59.097C58.3683 59.8881 57.7776 59.2973 57.7776 58.5686Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M129.904 88.8877H110.651C107.53 88.8877 105 91.4178 105 94.5388V110.634C105 113.755 107.53 116.285 110.651 116.285H129.904C133.025 116.285 135.556 113.755 135.556 110.634V94.5388C135.556 91.4178 133.025 88.8877 129.904 88.8877Z",
    fill: "#74D8D6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.755 98.342C126.093 96.9518 127.672 93.1187 126.282 89.7806C124.892 86.4424 121.059 84.8633 117.72 86.2535C114.382 87.6438 112.803 91.4768 114.193 94.815C115.584 98.1531 119.417 99.7322 122.755 98.342Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.238 101.087C113.53 101.087 108.091 106.524 108.091 113.234C108.091 114.993 109.518 116.42 111.277 116.42H129.196C130.955 116.42 132.382 114.993 132.382 113.234C132.382 106.527 126.945 101.087 120.235 101.087H120.238Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4722 89.8883C43.4722 88.0473 44.9646 86.5549 46.8055 86.5549H93.0555C94.8964 86.5549 96.3888 88.0473 96.3888 89.8883V101.277C96.3888 103.118 94.8964 104.61 93.0555 104.61H46.8055C44.9646 104.61 43.4722 103.118 43.4722 101.277V89.8883Z",
    fill: "#17BEBB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1012 97.9203C48.2832 97.9203 46.8054 96.4411 46.8054 94.6245C46.8054 93.8495 47.4332 93.2217 48.2082 93.2217C48.9832 93.2217 49.611 93.8495 49.611 94.6245C49.611 95.1647 50.5915 95.1647 50.5915 94.6245C50.5915 93.8495 51.2193 93.2217 51.9943 93.2217C52.7693 93.2217 53.3971 93.8495 53.3971 94.6245C53.3971 96.4425 51.9179 97.9203 50.1012 97.9203Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0263 97.9203C58.2082 97.9203 56.7305 96.4411 56.7305 94.6245C56.7305 93.8495 57.3583 93.2217 58.1333 93.2217C58.9083 93.2217 59.536 93.8495 59.536 94.6245C59.536 95.1647 60.5166 95.1647 60.5166 94.6245C60.5166 93.8495 61.1444 93.2217 61.9194 93.2217C62.6944 93.2217 63.3221 93.8495 63.3221 94.6245C63.3221 96.4425 61.843 97.9203 60.0263 97.9203Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9513 97.9203C68.1333 97.9203 66.6555 96.4411 66.6555 94.6245C66.6555 93.8495 67.2833 93.2217 68.0583 93.2217C68.8333 93.2217 69.4611 93.8495 69.4611 94.6245C69.4611 95.1647 70.4416 95.1647 70.4416 94.6245C70.4416 93.8495 71.0694 93.2217 71.8444 93.2217C72.6194 93.2217 73.2472 93.8495 73.2472 94.6245C73.2472 96.4425 71.768 97.9203 69.9513 97.9203Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8764 97.9203C78.0583 97.9203 76.5806 96.4411 76.5806 94.6245C76.5806 93.8495 77.2083 93.2217 77.9833 93.2217C78.7583 93.2217 79.3861 93.8495 79.3861 94.6245C79.3861 95.1647 80.3667 95.1647 80.3667 94.6245C80.3667 93.8495 80.9945 93.2217 81.7695 93.2217C82.5445 93.2217 83.1722 93.8495 83.1722 94.6245C83.1722 96.4425 81.6931 97.9203 79.8764 97.9203Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8012 97.9203C87.9832 97.9203 86.5054 96.4411 86.5054 94.6245C86.5054 93.8495 87.1332 93.2217 87.9082 93.2217C88.6832 93.2217 89.3109 93.8495 89.3109 94.6245C89.3109 95.1647 90.2915 95.1647 90.2915 94.6245C90.2915 93.8495 90.9193 93.2217 91.6943 93.2217C92.4693 93.2217 93.097 93.8495 93.097 94.6245C93.097 96.4425 91.6179 97.9203 89.8012 97.9203Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3333 101.607C93.3333 99.0217 96.5079 97.7835 98.258 99.6858C100.16 101.436 98.9221 104.611 96.3372 104.611H96.2171C94.6244 104.611 93.3333 103.319 93.3333 101.727V101.607Z",
    fill: "#17BEBB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModoBup);
export default __webpack_public_path__ + "static/media/modoBUP.43bbcb65767284e3984f684c75d9c1d4.svg";
export { ForwardRef as ReactComponent };